import React from 'react';
import { Button } from '@mui/material';
import MuiFaIcon from '../../atomicDesign/atoms/MuiFaIcon';

const BackButton = ({ onClick, label = 'Back', icon = true, sx = {} }) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      disableRipple={false}
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: '4px 12px',
        textTransform: 'none',
        fontWeight: 500,
        color: '#666',
        backgroundColor: 'transparent',
        borderRadius: '4px',
        minHeight: '40px',
        ml: '-8px',
        '&:hover': {
          color: '#555',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '&:active': {
          color: '#555',
        },
        ...sx,
      }}
      startIcon={
        icon && (
          <MuiFaIcon
            name="fas fa-chevron-left"
            style={{ fontSize: '1rem', opacity: 0.7 }}
          />
        )
      }
    >
      {label}
    </Button>
  );
};

export default BackButton;
